import React, { ReactNode } from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  detailStart: {
    display: 'flex',
    flexGrow: 1,
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    paddingRight: '5px',
  },
  detailEnd: {
    display: 'flex',
    flexGrow: 1,
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    paddingLeft: '5px',
  },
});

/**
 * A simple wrapper to display details about the document to be printed, e.g. Sales Order Number, Customer Name, etc.
 * Content will expand to fill the available space and wrap if necessary.
 *
 * @param contentLeft - Typically a String (I.e. 'Order A113') but any ReactNode is permitted if something more complex is required (Like a link/hint/etc).
 * @param contentRight - Typically a String (I.e. 'Customer - Ink Incorporated') but any ReactNode is permitted if something more complex is required (Like a link/hint/etc).
 */
export const DocumentCarouselHeaderInfo = ({
  contentLeft,
  contentRight,
}: {
  contentLeft: ReactNode;
  contentRight: ReactNode;
}) => {
  const styles = useStyles();

  return (
    <div className={styles.wrapper}>
      <span className={styles.detailStart}>{contentLeft}</span>
      <span className={styles.detailEnd}>{contentRight}</span>
    </div>
  );
};
